import { AlertTriangle } from 'lucide-react';
import { useFilters } from '@/contexts/FilterContext';
import { Button } from './Button';

export function LocationErrorPrompt() {
  const { resetToGps } = useFilters();

  return (
    <div className="flex flex-col items-center justify-center py-16 px-6 text-center">
      <div className="mb-4 opacity-50">
        <AlertTriangle size={48} className="text-[var(--color-muted)]" />
      </div>
      <h2 className="text-lg font-semibold text-[var(--color-text)] mb-2">
        Location Unavailable
      </h2>
      <p className="text-sm text-[var(--color-muted)] max-w-sm leading-relaxed mb-4">
        We couldn't determine your location. Please check your connection and try again.
      </p>
      <Button onClick={resetToGps}>
        Retry
      </Button>
    </div>
  );
}
